export default {
  labels: {
    dont_have_account: 'Don’t have an account? ',
  },
  title: 'Log in',
  buttons: {
    sign_up: 'Sign up',
  },
};
